import { Menu, MenuItem } from '@app/types';
import React from 'react';
import MenuCard from './MenuCard';

type Props = {
  menus: Menu[];
  onAddMenuItemClick: (menuItem: MenuItem, menu: Menu) => void;
  onRechedTopOfScroll: (menu: Menu, index: number) => void;
};

export default function MenuCardList({ menus, onAddMenuItemClick, onRechedTopOfScroll }: Props) {
  function renderMenu(menu: Menu, index: number) {
    return (
      <MenuCard
        key={menu.id}
        menu={menu}
        index={index}
        onAddMenuItemClick={onAddMenuItemClick}
        onRechedTopOfScroll={onRechedTopOfScroll}
      />
    );
  }

  return <>{menus.map(renderMenu)}</>;
}
